import React from "react";
import { oneOfType, string, number } from "prop-types";
import styled, { css } from "styled-components";
import cx from "classnames";

import withTheme from "../styles/withTheme";
import { toFormat } from "../utils";

const EmptyContaienr = styled.div`
  span {
    font-size: 18px;
    color: #eee;
    font-weight: bold;
  }
`;

const Container = styled.div``;

const Text = styled.span`
  ${props =>
    !props.isZero &&
    css`
      color: ${props.isPositive ? props.upColor : props.downColor};
    `};
`;

const Icon = styled.i`
  ${props => css`
    margin-right: 3px;
    color: ${props.up ? props.upColor : props.downColor};
  `};
`;

export const Return = ({ rtn, color, id, upColor, downColor }) => {
  const isPositive = rtn > 0;
  const displayText = `${toFormat(Math.abs(rtn) * 100)}%`;
  const isZero = displayText === "0.00%";
  if ((!rtn && rtn !== 0) || rtn === "-") {
    return (
      <EmptyContaienr>
        <span id="t-u-return">-</span>
      </EmptyContaienr>
    );
  }
  return (
    <Container
      id={id}
      className={cx("return-container", {
        up: isPositive && !isZero,
        down: !isPositive && !isZero,
        zero: isZero
      })}
    >
      {!isZero ? (
        isPositive ? (
          <Icon
            upColor={upColor}
            downColor={downColor}
            up
            className="fa fa-caret-up"
            aria-hidden="true"
          />
        ) : (
          <Icon
            upColor={upColor}
            downColor={downColor}
            className="fa fa-caret-down"
            aria-hidden="true"
          />
        )
      ) : null}
      <Text
        id="t-display-text"
        isZero={isZero}
        isPositive={isPositive}
        upColor={upColor}
        downColor={downColor}
      >
        {displayText}
      </Text>
    </Container>
  );
};

Return.propTypes = {
  id: string,
  color: string,
  rtn: oneOfType([string, number]),
  upColor: string,
  downColor: string
};

Return.defaultProps = {
  id: null,
  color: null,
  rtn: null,
  upColor: "red",
  downColor: "green"
};

export const mapThemeToProps = theme => {
  return {
    upColor: theme.color.return.up,
    downColor: theme.color.return.down
  };
};

export default withTheme(mapThemeToProps)(Return);



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Return/Return.js